import React from 'react';
import { View, TouchableOpacity, Image } from 'react-native';
import Typography from 'src/components/Text/Text';
import { styles, getHeaderStyle } from './QuoteCard.styles';
import { CardHeaderProps } from './QuoteCard.types';

import arrowUp from 'src/assets/arrowUp.png';
import arrowDown from 'src/assets/arrowDown-3x.png';
import checkIcon from 'src/assets/check.png';

const QuoteCardHeader: React.FC<CardHeaderProps> = ({
  price,
  coverage,
  logo,
  isSelected,
  isExpanded,
  onToggleExpand,
}) => (
  <View style={getHeaderStyle(isSelected, isExpanded)}>
    {isSelected && (
      <View style={styles.checkIconContainer}>
        <Image source={checkIcon} style={styles.checkIcon} resizeMode="contain" />
      </View>
    )}
    <View style={styles.cardHeader}>
      <View style={styles.cardHeaderLeft}>
        <Image source={{ uri: logo }} style={styles.providerLogo} />
        <View>
          <Typography variant="h4" style={styles.priceText}>
            {price}
          </Typography>
          <Typography variant="title2" style={styles.coverageText}>
            {coverage}
          </Typography>
        </View>
      </View>
      <TouchableOpacity onPress={onToggleExpand} style={styles.arrowIconContainer}>
        <Image
          source={isExpanded ? arrowUp : arrowDown}
          style={styles.arrowIcon}
          resizeMode="contain"
        />
      </TouchableOpacity>
    </View>
  </View>
);

export default QuoteCardHeader;
